import React, { Fragment } from 'react';
import { compose, lifecycle, withProps, withState } from 'recompose';
import {
  ErrorMessage,
  LoadingMessage,
  TimeAgo,
  C,
} from '@kineticdata/bundle-common';
import { actions } from '../../../redux/modules/surveys';
import { connect } from '../../../redux/store';
import { I18n } from '@kineticdata/react';
import { PageTitle } from '../../shared/PageTitle';
import { CoreStateBadge } from '../../shared/StatusBadge';

export const SubmissionDetailsContainer = ({
  kapp,
  form,
  formActions,
  callFormAction,
  submission,
  submissionError,
  profile,
  asideOpen,
  toggleAsideOpen,
}) =>
  form && (
    <div className="page-container">
      <div className="page-panel">
        <PageTitle
          parts={[submission && submission.handle, form && form.name]}
          breadcrumbs={[
            {
              label: (
                <span>
                  <span className="fa fa-fw fa-md fa-arrow-left text-muted" />
                  <I18n>{C.SETTINGS_LABEL}</I18n>
                </span>
              ),
              to: '/settings',
            },
            { label: 'Survey Management', to: '../../../..' },
            { label: `${form.name}`, to: '../..' },
          ]}
          title={submission ? submission.label : 'New Submission'}
          actions={
            form.status === 'Active' &&
            formActions.map(el => ({
              key: el.slug,
              label: el.name,
              onClick: () =>
                callFormAction({
                  formSlug: el.slug,
                  surveySubmission: submission,
                }),
              menu: true,
            }))
          }
        />

        {submissionError ? (
          <ErrorMessage message={submissionError.message} />
        ) : !submission ? (
          <LoadingMessage />
        ) : (
          <div>
            <div className="data-list data-list--fourths">
              <dl>
                <dt>Submission Id</dt>
                <dd>{submission.id}</dd>
              </dl>
              <dl>
                <dt>Status</dt>
                <dd>
                  <CoreStateBadge coreState={submission.coreState} />
                </dd>
              </dl>
              <dl>
                <dt>Created</dt>
                <dd>
                  <TimeAgo timestamp={submission.createdAt} />
                  <br />
                  <small>
                    <I18n>by</I18n> {submission.createdBy}
                  </small>
                </dd>
              </dl>
              <dl>
                <dt>Submitted</dt>
                <dd>
                  {submission.submittedAt ? (
                    <Fragment>
                      <TimeAgo timestamp={submission.submittedAt} />
                      <br />
                      <small>
                        <I18n>by</I18n> {submission.submittedBy}
                      </small>
                    </Fragment>
                  ) : (
                    <I18n>N/A</I18n>
                  )}
                </dd>
              </dl>
            </div>
            <div className="section__title">
              <span className="title">
                <I18n>Submission Activity</I18n>
              </span>
            </div>
            <div className="section__content scroll-wrapper-h">
              {submission.activities.filter(
                activity => activity.type !== 'Task',
              ).length > 0 ? (
                <table className="table table-sm table--settings m-0">
                  <thead className="header">
                    <tr>
                      <th scope="col">
                        <I18n>Timestamp</I18n>
                      </th>
                      <th scope="col">
                        <I18n>Type</I18n>
                      </th>
                      <th scope="col">
                        <I18n>Label</I18n>
                      </th>
                      <th scope="col">
                        <I18n>Description</I18n>
                      </th>
                      <th scope="col">
                        <I18n>Data</I18n>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {submission.activities
                      .filter(activity => activity.type !== 'Task')
                      .map((activity, index) => {
                        const data = activity.data
                          ? JSON.parse(activity.data)
                          : {};
                        return (
                          <tr key={`activity-${index}`}>
                            <td>
                              <TimeAgo timestamp={activity.createdAt} />
                            </td>
                            <td>{activity.type}</td>
                            <td>{activity.label}</td>
                            <td>{activity.description}</td>
                            <td>
                              {Object.keys(data).map(key => (
                                <div key={key}>
                                  {key}: {data[key]}
                                </div>
                              ))}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              ) : (
                <I18n>There is no submission activity</I18n>
              )}
            </div>
            <div className="section__title">
              <span className="title">
                <I18n>Values</I18n>
              </span>
            </div>
            <div className="section__content scroll-wrapper-h">
              <table className="table table-sm table--settings m-0">
                <thead className="header">
                  <tr>
                    <th scope="col">
                      <I18n>Field</I18n>
                    </th>
                    <th scope="col">
                      <I18n>Value</I18n>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {submission.form.fields.map(field => (
                    <tr key={field.name}>
                      <td>
                        <I18n>{field.name}</I18n>
                      </td>
                      <td>{submission.values[field.name]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );

const mapStateToProps = state => ({
  kapp: state.app.kapp,
  forms: state.surveyApp.forms,
  formActions: state.surveyApp.formActions,
  submission: state.surveys.submission,
  submissionError: state.surveys.submissionError,
  profile: state.app.profile,
});

const mapDispatchToProps = {
  fetchSubmissionRequest: actions.fetchSubmissionRequest,
  callFormAction: actions.callFormAction,
};

export const SubmissionDetails = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(props => ({
    form: props.forms && props.forms.find(form => form.slug === props.slug),
  })),
  withState('asideOpen', 'toggleAsideOpen', false),
  lifecycle({
    componentWillMount() {
      this.props.fetchSubmissionRequest({
        id: this.props.submissionId,
      });
    },
  }),
)(SubmissionDetailsContainer);
